<template>
  
  <div>
  <div v-if="isExist&&!linkIAmSmart&&!isCompleted">The digital certificate is registered as a ESH account. Please login to activate your professional role.</div>
    <nx-bform v-if="!linkIAmSmart&&!isCompleted"
            ref="form"
            @submit="onSubmit"
            class="e-registration-professional-register-form"
    >
      <h5>
        {{ $t("title") }}
      </h5>
      <p class="text-muted">
        {{ $t("titleDesc") }}
      </p>

      <nx-bform-server-errors />

      <!-- <RegistrationHaveEshAcFormGroup
              label-cols="2"
              label-align="right"
              v-model="form.haveAc"
              required
              v-if="!isExist"
      /> -->

      <template v-if="isRegisteredIAmSmartAccount">
        <RegistrationEnglishNameFormGroup label-cols="2" label-align="right">
          <div class="plain-text-field">{{ iamsmartSession.userEngName }}</div>
        </RegistrationEnglishNameFormGroup>

        <b-form-group
                :label="$t('typeOfAccount')"
                label-cols="2"
                label-align="right"
        >
          
            <div class="plain-text-field"><label>Public User</label></div>
          
          
        </b-form-group>

       

      </template>

      <template v-if="!isRegisteredIAmSmartAccount">


        <RegistrationLoginNameNewFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.username"
                required
        />

        <RegistrationNameTitleFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.title"
          required
        />




        <!-- <RegistrationHKIDNumberFormGroup
          label-cols="2"
          label-align="right"
          description=""
        >
          {{ userInfo.idNo }}
        </RegistrationHKIDNumberFormGroup> -->

      

        <RegistrationEmailFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.email"
                required
        />

        <RegistrationLanguageFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.lang"
          required
        />

        

        

        <CaptchaFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.captcha"
                @change-token="form.captchaToken = $event.token"
                required
        /> 
      </template>

      <nx-bform-server-errors />

      <b-form-group label-cols="2">
        <b-button type="submit" variant="primary" v-t="'send'" />
        <b-button class="ml-2" @click="resetForm" v-t="'cancel'" />
      </b-form-group>
    </nx-bform>
    <AfterRegisterCompleted v-if="isCompleted" :exist="true"  @useESS="useESS"/>
    <AfterLinkedIAmSmart v-if="linkIAmSmart" :exist="false" @useESS="useESS"/>
  </div>
 
</template>

<script>
import { assign } from "lodash";
import { EshApi,MemberRegistrationApi } from "@/api";
import cert from "@/assets/cert.json";
import moment from "moment";
import { FileUtil, UserApi } from "nx-libs";
import { UserService } from "@/services";
import RegistrationEnglishNameFormGroup from "@/forms/registration/RegistrationEnglishNameFormGroup";
import RegistrationChineseNameFormGroup from "@/forms/registration/RegistrationChineseNameFormGroup";
//import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
//import RegistrationDateOfBirthFormGroup from "@/forms/registration/RegistrationDateOfBirthFormGroup";
import RegistrationEmailFormGroup from "@/forms/registration/RegistrationEmailFormGroup";
import RegistrationTelephoneFormGroup from "@/forms/registration/RegistrationTelephoneFormGroup";
import RegistrationFaxFormGroup from "@/forms/registration/RegistrationFaxFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import RegistrationLoginNameFormGroup from "@/forms/registration/RegistrationLoginNameFormGroup";
import RegistrationPasswordFormGroup from "@/forms/registration/RegistrationPasswordFormGroup";
import RegistrationPasswordNewFormGroup from "@/forms/registration/RegistrationPasswordNewFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";
import RegistrationLanguageFormGroup from "@/forms/registration/RegistrationLanguageFormGroup";
import RegistrationHaveEshAcFormGroup from "@/forms/registration/RegistrationHaveEshAcFormGroup";
import RegistrationLoginNameNewFormGroup from "@/forms/registration/RegistrationLoginNameNewFormGroup";
import RegistrationContactAddressLongFormGroup from "@/forms/registration/RegistrationContactAddressLongFormGroup";
import { IAMSmartAuthApi } from "@nextore/iam-smart";
import AfterLinkedIAmSmart from "../../../login/components/login/AfterLinkedIAmSmart";
import AfterRegisterCompleted from '@/public/modules/login/components/login/AfterRegisterCompleted.vue';

export default {
  props: [ "businessId","iamsmartSession"],
  components: {
    RegistrationEnglishNameFormGroup,
    RegistrationChineseNameFormGroup,
    //RegistrationHKIDNumberFormGroup,
    //RegistrationDateOfBirthFormGroup,
    RegistrationEmailFormGroup,
    RegistrationTelephoneFormGroup,
    RegistrationFaxFormGroup,
    CaptchaFormGroup,
    RegistrationLoginNameFormGroup,
    RegistrationPasswordFormGroup,
    RegistrationPasswordNewFormGroup,
    RegistrationESignatureFormGroup,
    RegistrationLanguageFormGroup,
    RegistrationHaveEshAcFormGroup,
    RegistrationLoginNameNewFormGroup,
    RegistrationContactAddressLongFormGroup,
    AfterLinkedIAmSmart,
    AfterRegisterCompleted
  },
  data() {
    return {
      haveAc: false,
      form: {},
      linkIAmSmart: false,
      isCompleted:false,
      isExist:false,
      memberCertificationGuid:"",
      errors: []
    };
  },
  mounted() {
    this.$watch(
      () => {
        this.errors = this.$refs.form.observer.errors['server-errors']
    }) 
  },
  watch: {

    iamsmartSession: {
      immediate: true,
      handler(iamsmartSession) {
        if (iamsmartSession) {
          this.form.fullname = this.normalizeFullname(iamsmartSession.userEngName);
          this.form.haveAc = this.isRegisteredIAmSmartAccount ? true : false;
        }
      }
    },
    errors() {
      // console.log("first", $('.form-control.is-invalid:first'))
      // console.log("errors", this.errors)
      // if($('.form-control.is-invalid:first').length > 0) {
        $('.form-control.is-invalid:first')[0].offsetParent.scrollIntoView({behavior: 'smooth'});
      // }
    },
  },
  computed: {
   
    isRegisteredIAmSmartAccount() {
      return Boolean(this.iamsmartSession?.memberID);
    }
    
  },
  methods: {
    getForm() {
      return {
        haveAc: false,
        telephone: "",
        username: "",
        password: "",
        confirmPassword: "",
        lang: "en",
        captcha: "",
        captchaToken: "",
        defaultPosition: null,
        contactAddress: {},
        email: "",
        fax: ""
      };
    },
    async onSubmit(evt) {
       this.$spinner.show();
       try{
        const { form, sessionKey, eCert } = this;
        const registry = {
          sessionKey: this.businessId ? this.businessId : sessionKey,
          eCert: this.businessId ? (form.eCert ? await FileUtil.toBase64NoType(form.eCert) : null) : eCert,
          phone: form.telephone,
          defaultPosition: form.defaultPosition
        };

        let login = {
          Username: form.username,
          Password: form.password
        };

        if (!form.haveAc) {
          assign(registry, {
            registrationProfileKey: "PublicUser",
            loginName: form.username,
            language: form.lang,
            email: form.email,
            propertyValues: {
                  hkidNumber: form.idNo,
                  title: form.title
                },
          });
        }

        if (form.haveAc) {
          await MemberRegistrationApi.loginPublicUser({
            LdapID:5,
            SessionKey:this.sessionKey,
            BusinessID:this.businessId
          });
    

          this.isCompleted=true;
          //await MemberRegistrationApi.upgradeProfessional(registry);
        } else {
          await MemberRegistrationApi.registerPublicUser(
            registry,
            this.businessId
          );
          //remove auto login
          //await UserApi.login(5, login);
          this.linkIAmSmart = true;
          // UserService.redirectToLanding("prof");
        }
      }
      finally{
         this.$spinner.hide();
      }
      

    },
    normalizeFullname(fullname) {
      return (fullname || '').split(',').join('');
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
      this.$router.push({ name: 'LoginPublic' });
    },
    async useESS() {
      this.$router.push({ name: 'LoginPublic' });
    }
  }
};
</script>

<style lang="scss" scoped>
.plain-text-field {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/registration.locale"></i18n>

<i18n src="@/locales/login.locale"></i18n>

<i18n>
{
  "en": {
    "title": "To register public user account",
    "titleDesc": "Please complete the following (all fields with (*) are mandatory for completion):"
  },
  "zh_hk": {
    "title": "註冊的人士公眾帳戶",
    "titleDesc": "請完成以下操作（所有帶有（*）的字段均為必填項）："
  },
  "zh_cn": {
    "title": "注册公眾人士帐户",
    "titleDesc": "请完成以下操作（所有带有（*）的字段均为必填项）："
  }
}
</i18n>
